/* ===========================================================================
   Tyrrel Professional — LP da loja internacional oficial dentro da MKPBR
   v2 — 22/09/2026, no molde da Popozuda (19/09/2026): vitrine, ficha do
   produto, carrinho proprio, busca local, seletores e faixa de mercado, mais
   o carrossel do banner com as 3 fotos de campanha da marca, as LINHAS da
   marca (Alinhamento, Tratamentos, Home care, Finalizadores) como filtro da
   vitrine e o "Monte seu kit".

   DEGRAUS DO DESCONTO: 2 itens = 5%, 3 = 10%, 4+ = 15%, contando o TOTAL DE
   ITENS DO CARRINHO (soma produtos diferentes). Quem APLICA e o app Pumper,
   no servidor — esta pagina so mostra. Os degraus vem do #ty-cfg.
   =========================================================================== */
(function () {
  'use strict';

  var D = document;
  var $ = function (s, r) { return (r || D).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); };
  var REDUZ = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- dados ------------------------------------------------------ */
  function readJSON(id, fallback) {
    var el = D.getElementById(id);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { console.error('[tyrrel] JSON invalido em #' + id, e); return fallback; }
  }
  var CFG = readJSON('ty-cfg', {});
  var RAW = readJSON('ty-data', []);
  var ISO = CFG.iso || D.documentElement.lang || 'en';
  var PACK = readJSON('ty-i18n', {});
  function t(k) { return PACK[k] || ''; }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function fmtNum(n) {
    try { return new Intl.NumberFormat(ISO + '-u-nu-latn').format(n); } catch (e) { return String(n); }
  }

  /* O Liquid devolve numero como texto em varios campos (a nota chega como
     "4.9"). Converte UMA vez, logo depois de ler o JSON. */
  function normVar(v) {
    v.pr = Number(v.pr) || 0;
    v.prf = String(v.prf == null ? '' : v.prf);
    v.cmpf = v.cmpf ? String(v.cmpf) : null;
    v.av = v.av === true || v.av === 'true';
    v.t = String(v.t == null ? '' : v.t);
    return v;
  }
  function tagSet(p) { return p.tags.map(function (x) { return String(x).toLowerCase(); }); }
  function ehKit(p) {
    var h = String(p.h).toLowerCase();
    return /(^|-)kit(-|$)|-set$|-set-|-duo$|-duo-/.test(h);
  }
  function prepara(lista) {
    return (lista || []).filter(function (p) { return p && p.h && p.v && p.v.length; }).map(function (p) {
      p.v = p.v.map(normVar);
      p.img = Array.isArray(p.img) ? p.img.filter(function (i) { return i && i.s; }) : [];
      p.tags = Array.isArray(p.tags) ? p.tags : [];
      p.rr = p.rr == null ? null : parseFloat(p.rr);
      if (!isFinite(p.rr)) p.rr = null;
      p.rc = Math.round(parseFloat(p.rc) || 0);
      p.c = String(p.c || '');
      p.av = p.v.some(function (v) { return v.av; });
      var disp = p.v.filter(function (v) { return v.av; });
      var base = (disp.length ? disp : p.v).slice().sort(function (a, b) { return a.pr - b.pr; });
      p.min = base[0];
      /* "a partir de" so quando os precos REALMENTE diferem */
      p.faixa = p.v.length > 1 && p.v.some(function (v) { return v.pr !== p.v[0].pr; });
      p.multi = p.v.length > 1;
      p.isKit = ehKit(p);
      p.isNew = !!(CFG.newSince && p.c && p.c >= String(CFG.newSince));
      p.fam = familiaDe(p);
      return p;
    });
  }
  var PRODUCTS = prepara(RAW);
  function porHandle(h) {
    for (var i = 0; i < PRODUCTS.length; i++) if (PRODUCTS[i].h === h) return PRODUCTS[i];
    return null;
  }

  /* ---------- dinheiro ---------------------------------------------------
     Cards e ficha usam v.prf, que o Liquid ja formatou. No carrinho, o
     #ty-cfg traz 12345,67 formatado pela loja: daqui sai o simbolo, a posicao
     e os separadores — o carrinho fica igual aos cards. */
  var CURRENCY = CFG.cur || 'USD';
  var MF = (function (tpl) {
    var m = /\d[\d.,'\s  ]*\d/.exec(String(tpl || ''));
    if (!m) return null;
    var num = m[0], dec = /([.,])\d{2}$/.exec(num), mil = /^12(\D+)34/.exec(num);
    return { pre: tpl.slice(0, m.index), pos: tpl.slice(m.index + num.length), dec: dec ? dec[1] : '', sep: mil ? mil[1] : '' };
  })(CFG.mfmt);
  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    if (MF && CURRENCY === CFG.cur) {
      var casas = MF.dec ? 2 : 0, fix = n.toFixed(casas).split('.');
      var inteiro = fix[0].replace(/\B(?=(\d{3})+(?!\d))/g, MF.sep);
      return MF.pre + inteiro + (casas ? MF.dec + fix[1] : '') + MF.pos;
    }
    try { return new Intl.NumberFormat(ISO, { style: 'currency', currency: CURRENCY }).format(n); }
    catch (e) { return CURRENCY + ' ' + n.toFixed(2); }
  }
  function parseMoney(s) {
    var n = String(s == null ? '' : s).replace(/[^\d.,]/g, '');
    if (!n) return NaN;
    var dec = /[.,](\d{1,2})$/.exec(n);
    if (dec) return parseFloat(n.slice(0, n.length - dec[0].length).replace(/[.,]/g, '') + '.' + dec[1]);
    return parseFloat(n.replace(/[.,]/g, ''));
  }

  /* ---------- linha (familia) --------------------------------------------------
     O mapa handle -> linha esta no #ty-cfg ("fam"). Produto NOVO fora do mapa
     cai numa linha pelo handle (em ingles, nao muda com o idioma) — a v1 so
     tinha 18 handles no mapa e os novos caiam todos em "tratamentos". */
  function familiaDe(p) {
    var f = CFG.fam && CFG.fam[p.h];
    if (f) return f;
    var h = String(p.h || '').toLowerCase();
    if (/oxireduct|reductblond|defrisaxx|keratin|smoothing|alignment|straight/.test(h)) return 'align';
    if (/oil|fluid|spray|mist|serum|leave|definer|finish|renova|heat|thermal/.test(h)) return 'finish';
    if (/(^|-)kit(-|$)|-duo|shampoo|home-care/.test(h)) return 'home';
    return 'treat';
  }

  /* ---------- nome curto ---------------------------------------------------
     O titulo da MKPBR e longo (tamanho, beneficios, medidas). No CARD vai o
     titulo SEM o nome da marca e cortado no primeiro separador (" – ");
     a ficha e o aria-label levam o titulo completo. O titulo ja vem
     traduzido pelo Shopify no idioma da pagina. */
  function curto(p) {
    var s = String(p.t || '').replace(/^\s*Tyrrel(\s+Professional)?\s+/i, '');
    var m = s.split(/\s[–—-]\s|\s\|\s|（|、|،\s/)[0].trim();
    return (m && m.length >= 6) ? m : s;
  }
  function curtoLinha(it) {
    var p = porHandle(it.handle);
    return p ? curto(p) : (it.product_title || it.title);
  }

  /* ---------- imagens com srcset -------------------------------------------- */
  function imgW(src, w) {
    if (!src) return '';
    return /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=' + w) : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function srcset(src) { return [300, 450, 600].map(function (w) { return imgW(src, w) + ' ' + w + 'w'; }).join(', '); }

  /* ---------- selo da Entrega Garantida --------------------------------------
     Abaixo de ~20px a arte oficial (que tem texto) vira borrao: no micro-selo
     do card entra o escudo em SVG. */
  var ESCUDO = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M12 2.6 4.6 5.4v6c0 4.4 3.1 8.5 7.4 9.9 4.3-1.4 7.4-5.5 7.4-9.9v-6L12 2.6Z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
    '<path d="M8.6 12.1l2.3 2.3 4.5-4.6" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SELO = CFG.seloUrl ? '<img class="ty-selo-img" src="' + esc(CFG.seloUrl) + '" alt="" width="120" height="126" loading="lazy">' : ESCUDO;
  var CARRINHO = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3.5 4h2l2.2 10.2a1.6 1.6 0 0 0 1.6 1.3h7.9a1.6 1.6 0 0 0 1.5-1.2L20.5 8H6.6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9.6" cy="19.4" r="1.4" fill="currentColor"/><circle cx="17" cy="19.4" r="1.4" fill="currentColor"/></svg>';

  /* ---------- cards ---------------------------------------------------------- */
  function desconto(v) {
    if (!v || !v.cmpf) return null;
    var de = parseMoney(v.cmpf), por = parseMoney(v.prf);
    if (!isFinite(de) || !isFinite(por) || de <= por) return null;
    return { pct: Math.round((1 - por / de) * 100) };
  }
  function precoHTML(p, v) {
    v = v || p.min;
    var corpo = (v.cmpf ? '<s>' + esc(v.cmpf) + '</s>' : '') + '<b>' + esc(v.prf) + '</b>';
    return (p.faixa && v === p.min ? '<span class="ty-card__from">' + esc(t('from')) + '</span>' : '') + corpo;
  }
  function badgesHTML(p, v) {
    var d = desconto(v || p.min);
    if (!d || d.pct < 5) return '';
    return '<span class="ty-b ty-b--promo">' + esc(t('promo')) + '</span><span class="ty-b">' + d.pct + '% ' + esc(t('off')) + '</span>';
  }
  /* Estrelas SO quando o produto tem nota cadastrada (metafield de reviews). Nada de nota inventada. */
  function starsHTML(p) {
    if (!p.rr || !p.rc) return '';
    var cheias = Math.round(p.rr);
    return '<div class="ty-stars" aria-label="' + esc(p.rr.toFixed(1) + ' / 5') + '"><i aria-hidden="true">' +
      '★★★★★'.slice(0, cheias) + '☆☆☆☆☆'.slice(0, 5 - cheias) + '</i>(' + fmtNum(p.rc) + ')</div>';
  }
  function imgHTML(p) {
    var img = p.img[0] || {};
    var d = desconto(p.min);
    return '<div class="ty-card__img">' +
      (img.s ? '<img src="' + esc(imgW(img.s, 450)) + '" srcset="' + esc(srcset(img.s)) + '" sizes="(max-width:767px) 55vw, 330px"' +
        ' alt="' + esc(img.a || p.t) + '" loading="lazy" decoding="async" width="600" height="600">' : '') +
      (p.isNew && p.av ? '<span class="ty-card__new">' + esc(t('new_b')) + '</span>' : '') +
      (!p.av ? '<span class="ty-card__flag">' + esc(t('soldout')) + '</span>' : (d && d.pct >= 5 ? '<span class="ty-card__off">' + d.pct + '% ' + esc(t('off')) + '</span>' : '')) +
      '<span class="ty-card__quick" aria-hidden="true">' + esc(t('quick')) + '</span>' +
    '</div>';
  }
  /* O card NAO pode ser um <button> (botao dentro de botao e HTML invalido):
     div com role=button, e o clique no botao de comprar e tratado ANTES. */
  function cardEl(p) {
    var el = D.createElement('div');
    el.className = 'ty-card' + (p.av ? '' : ' ty-card--out');
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.setAttribute('aria-label', p.t);
    el.dataset.tyHandle = p.h;
    var rotulo = !p.av ? t('soldout') : (p.multi ? t('pdp_choose_card') : t('add'));
    var attr = p.multi ? ' data-ty-open-handle="' + esc(p.h) + '"' : ' data-ty-add="' + p.min.id + '"';
    el.innerHTML = imgHTML(p) +
      '<div class="ty-card__body"><div>' +
        '<h3>' + esc(curto(p)) + '</h3>' + starsHTML(p) +
        '<div class="ty-card__price">' + precoHTML(p) + '</div>' +
        /* micro-selo da Entrega Garantida: responde antes do clique */
        '<span class="ty-card__del">' + ESCUDO + esc(t('del_card')) + '</span>' +
      '</div>' +
      '<button type="button" class="ty-card__add"' + attr + (p.av ? '' : ' disabled') + ' aria-label="' + esc(rotulo + ' — ' + curto(p)) + '">' + CARRINHO + '</button>' +
      '</div>';
    return el;
  }
  /* Card do "Monte seu kit": o do bloco oficial (foto, nome, preco e botao
     "Adicionar" de largura inteira) — o botao poe no KIT, o card abre a ficha. */
  function kcardEl(p) {
    var el = D.createElement('div');
    el.className = 'ty-kcard' + (p.av ? '' : ' ty-kcard--out');
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.setAttribute('aria-label', p.t);
    el.dataset.tyHandle = p.h;
    var dentro = KIT.indexOf(p.h) > -1;
    el.innerHTML = imgHTML(p) +
      '<div class="ty-kcard__t"><h3>' + esc(curto(p)) + '</h3>' + starsHTML(p) +
        '<div class="ty-card__price">' + precoHTML(p) + '</div>' +
        '<span class="ty-card__del">' + ESCUDO + esc(t('del_card')) + '</span></div>' +
      '<button type="button" class="ty-btn ty-kcard__add' + (dentro ? ' is-in' : '') + '" data-ty-kit="' + esc(p.h) + '" aria-pressed="' + dentro + '"' + (p.av ? '' : ' disabled') + '>' +
        esc(!p.av ? t('soldout') : (dentro ? t('kit_in') : t('kit_add'))) + '</button>';
    return el;
  }
  function pinta(grid, lista, fab) {
    if (!grid) return;
    grid.innerHTML = '';
    grid.setAttribute('aria-busy', 'false');
    lista.forEach(function (p) { grid.appendChild((fab || cardEl)(p)); });
  }
  /* disponivel antes de esgotado; dentro disso, a ordem da lista */
  function dispPrimeiro(lista) {
    return lista.map(function (p, i) { return { p: p, i: i }; })
      .sort(function (a, b) { return (a.p.av === b.p.av) ? a.i - b.i : (a.p.av ? -1 : 1); })
      .map(function (x) { return x.p; });
  }
  function daLista(handles) { return (handles || []).map(porHandle).filter(Boolean); }
  function todosEmOrdem() {
    var ordem = daLista(CFG.order);
    var resto = PRODUCTS.filter(function (p) { return ordem.indexOf(p) < 0; });
    return dispPrimeiro(ordem.concat(resto));
  }
  function listaDaAba(k) {
    if (k === 'best') return dispPrimeiro(daLista(CFG.best));
    if (k === 'news') {
      /* cadastrados nos ultimos 120 dias, do mais novo para o mais antigo */
      return dispPrimeiro(PRODUCTS.filter(function (p) { return p.isNew; })
        .sort(function (a, b) { return a.c < b.c ? 1 : (a.c > b.c ? -1 : 0); }));
    }
    if (k === 'kits') return dispPrimeiro(PRODUCTS.filter(function (p) { return p.isKit; }));
    return todosEmOrdem();
  }

  /* ---------- abas "Descubra a Tyrrel Professional" ---------------------------------- */
  var TAB = 'best';
  function pintaAbas() {
    $$('[data-ty-tab]').forEach(function (b) { b.hidden = !listaDaAba(b.dataset.tyTab).length; });
    var atual = $('[data-ty-tab="' + TAB + '"]');
    if (atual && atual.hidden) {
      var primeira = $$('[data-ty-tab]').filter(function (b) { return !b.hidden; })[0];
      if (primeira) TAB = primeira.dataset.tyTab;
    }
    $$('[data-ty-tab]').forEach(function (x) {
      var on = x.dataset.tyTab === TAB;
      x.classList.toggle('is-on', on);
      x.setAttribute('aria-selected', String(on));
      x.tabIndex = on ? 0 : -1;
    });
    pinta($('[data-ty-grid="tabs"]'), listaDaAba(TAB));
    var rail = $('[data-ty-rail="tabs"]');
    if (rail) { var tr = $('.ty-rail__track', rail); if (tr) tr.scrollLeft = 0; ligaRail(rail); }
  }
  function selecionaAba(k, foco) {
    TAB = k;
    pintaAbas();
    if (foco) { var b = $('[data-ty-tab="' + k + '"]'); if (b) b.focus(); }
  }
  function ligaAbas() {
    var abas = $$('[data-ty-tab]');
    abas.forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); selecionaAba(b.dataset.tyTab); });
      b.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var vis = abas.filter(function (x) { return !x.hidden; });
        var i = vis.indexOf(b);
        var passo = (e.key === 'ArrowRight' ? 1 : -1) * (D.documentElement.dir === 'rtl' ? -1 : 1);
        var alvo = vis[(i + passo + vis.length) % vis.length];
        if (alvo) { e.preventDefault(); selecionaAba(alvo.dataset.tyTab, true); }
      });
    });
  }

  /* ---------- carrossel de cards: scroll NATIVO; setas e barra acompanham ---------- */
  function atualizaRail(rail) {
    if (!rail) return;
    var track = $('.ty-rail__track', rail);
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth;
    var x = Math.abs(track.scrollLeft); /* em RTL o Chrome devolve scrollLeft negativo */
    var prev = $('[data-ty-rail-prev]', rail), next = $('[data-ty-rail-next]', rail), prog = $('[data-ty-rail-prog]', rail);
    var sobra = max > 4;
    if (prev) prev.disabled = !sobra || x < 8;
    if (next) next.disabled = !sobra || x > max - 8;
    if (prog) {
      var vis = track.scrollWidth ? Math.min(1, track.clientWidth / track.scrollWidth) : 1;
      prog.style.width = (vis * 100) + '%';
      prog.style.insetInlineStart = (sobra ? (x / max) * (1 - vis) * 100 : 0) + '%';
    }
    var foot = $('.ty-rail__foot', rail);
    if (foot) foot.style.visibility = sobra ? '' : 'hidden';
  }
  function ligaRail(rail) {
    if (!rail) return;
    var track = $('.ty-rail__track', rail);
    if (!track) return;
    if (!rail.dataset.pronto) {
      rail.dataset.pronto = '1';
      track.addEventListener('scroll', function () { atualizaRail(rail); }, { passive: true });
      track.addEventListener('load', function () { atualizaRail(rail); }, true);
      $$('[data-ty-rail-prev],[data-ty-rail-next]', rail).forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var dir = b.hasAttribute('data-ty-rail-next') ? 1 : -1;
          if (D.documentElement.dir === 'rtl') dir = -dir;
          var card = $('.ty-card', track);
          var passo = card ? card.getBoundingClientRect().width + 10 : track.clientWidth * 0.8;
          track.scrollBy({ left: dir * passo, behavior: REDUZ ? 'auto' : 'smooth' });
        });
      });
    }
    atualizaRail(rail);
    if (window.requestAnimationFrame) requestAnimationFrame(function () { atualizaRail(rail); });
    setTimeout(function () { atualizaRail(rail); }, 500);
  }

  /* ---------- vitrines ------------------------------------------------------------ */
  function renderGrids() {
    var vazio = !PRODUCTS.length;
    var painel = $('[data-ty-nostock]');
    if (painel) {
      if (vazio && !painel.childElementCount) { var tpl = $('[data-ty-nostock-tpl]'); if (tpl && tpl.content) painel.appendChild(tpl.content.cloneNode(true)); }
      painel.hidden = !vazio;
    }
    if (vazio) {
      $$('.ty-picks__head,[data-ty-rail="tabs"],#ty-shop,#ty-lines').forEach(function (s) { s.hidden = true; });
      return;
    }
    pintaAbas();
    pintaLinhas();
    pintaKitGrade();
    montaPopulares();
    /* atalhos para produto fora do mercado viram nada (link morto nao leva a lugar nenhum) */
    $$('.ty-foot [data-ty-open-handle]').forEach(function (a) { var li = a.closest('li'); if (li) li.hidden = !porHandle(a.dataset.tyOpenHandle); });
  }

  /* ==========================================================================
     MONTE SEU KIT — o kit so vive nesta visita; "Adicionar kit ao carrinho"
     manda tudo de uma vez e abre o carrinho (ali a intencao e fechar).
     ========================================================================== */
  var KIT = [];
  /* ---------- linhas: cartoes com a contagem do mercado + filtro da vitrine ---------- */
  var FIL = 'all';
  function contaLinha(f) { return PRODUCTS.filter(function (p) { return p.fam === f; }).length; }
  function pintaLinhas() {
    (CFG.fams || []).forEach(function (f) {
      var n = contaLinha(f);
      var li = $('[data-ty-fam-li="' + f + '"]');
      if (li) li.hidden = !n;
      var num = $('[data-ty-fam-n="' + f + '"]');
      if (num) num.textContent = n === 1 ? t('n_prod1') : t('n_prod').replace('{n}', fmtNum(n));
      var chip = $('[data-ty-fil="' + f + '"]');
      if (chip) chip.hidden = !n;
      $$('.ty-mfam [data-ty-fam="' + f + '"]').forEach(function (a) { var l = a.closest('li'); if (l) l.hidden = !n; });
    });
    if (FIL !== 'all' && !contaLinha(FIL)) FIL = 'all';
    pintaFiltro();
  }
  function pintaFiltro() {
    $$('[data-ty-fil]').forEach(function (b) {
      var on = b.dataset.tyFil === FIL;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', String(on));
    });
  }
  function filtra(f, rolar) {
    FIL = f || 'all';
    pintaFiltro();
    pintaKitGrade();
    pintaKit();
    if (rolar) {
      var alvo = D.getElementById('ty-shop');
      if (alvo) alvo.scrollIntoView({ behavior: REDUZ ? 'auto' : 'smooth', block: 'start' });
    }
  }
  function pintaKitGrade() {
    var lista = todosEmOrdem();
    if (FIL !== 'all') lista = lista.filter(function (p) { return p.fam === FIL; });
    pinta($('[data-ty-grid="all"]'), lista, kcardEl);
  }
  function degrauDe(total) {
    var at = null;
    (CFG.steps || []).forEach(function (s) { if (total >= s.q) at = s; });
    return at;
  }
  function pintaKit() {
    var box = $('[data-ty-kit]');
    if (!box) return;
    var slots = $('[data-ty-kit-slots]', box);
    if (slots) {
      var n = Math.max(4, KIT.length);
      var html = '';
      for (var i = 0; i < n; i++) {
        var p = porHandle(KIT[i]);
        if (p) {
          var im = p.img[0] ? imgW(p.img[0].s, 150) : '';
          html += '<span class="ty-kit__slot is-full">' + (im ? '<img src="' + esc(im) + '" alt="' + esc(curto(p)) + '" loading="lazy">' : '') +
            '<button type="button" data-ty-kit-rm="' + esc(p.h) + '" aria-label="' + esc(t('kit_rm') + ' — ' + curto(p)) + '">&times;</button></span>';
        } else {
          /* Espaco vazio: um "+" e o desconto que ele destrava (o Pumper conta o
             carrinho inteiro, entao o degrau e o de CART.count + esta posicao).
             Clicar leva aos produtos. Antes era so a moldura tracejada vazia, e
             parecia imagem quebrada (Rafael, 19/09/2026). */
          var dg = degrauDe(CART.count + i + 1);
          html += '<button type="button" class="ty-kit__slot ty-kit__slot--add" data-ty-kit-pick aria-label="' + esc(t('kit_empty')) + '">' +
            '<i aria-hidden="true">+</i>' + (dg ? '<small aria-hidden="true">\u2212' + dg.p + '%</small>' : '') + '</button>';
        }
      }
      slots.innerHTML = html;
    }
    var num = $('[data-ty-kit-n]', box);
    if (num) num.textContent = fmtNum(KIT.length);
    /* O Pumper conta o carrinho INTEIRO: o degrau aceso e o do que o carrinho
       VAI ter depois de somar o kit. */
    var total = CART.count + KIT.length;
    var at = KIT.length ? degrauDe(total) : null;
    $$('.ty-qd__step', box).forEach(function (el) { el.classList.toggle('ty-qd__step--on', !!at && Number(el.dataset.q) === at.q); });
    var msg = $('[data-ty-kit-msg]', box);
    if (msg) {
      if (!KIT.length) msg.textContent = t('kit_empty');
      else {
        var passos = CFG.steps || [], prox = null;
        for (var j = 0; j < passos.length; j++) if (total < passos[j].q) { prox = passos[j]; break; }
        if (prox) msg.textContent = t('kit_next').replace('{n}', fmtNum(prox.q - total)).replace('{p}', prox.p);
        else msg.textContent = t('kit_max').replace('{p}', (passos[passos.length - 1] || {}).p || '');
      }
    }
    var go = $('[data-ty-kit-go]', box);
    if (go) go.disabled = !KIT.length;
    $$('[data-ty-kit]', $('[data-ty-grid="all"]')).forEach(function (b) {
      var dentro = KIT.indexOf(b.dataset.tyKit) > -1;
      b.classList.toggle('is-in', dentro);
      b.setAttribute('aria-pressed', String(dentro));
      if (!b.disabled) b.textContent = dentro ? t('kit_in') : t('kit_add');
    });
  }
  /* Espaco vazio do kit clicado: rola ate os produtos, faz os botoes
     "Adicionar" pulsarem duas vezes e poe o foco no primeiro disponivel. */
  function mostraGradeKit() {
    var g = $('[data-ty-grid="all"]');
    if (!g) return;
    g.scrollIntoView({ behavior: REDUZ ? 'auto' : 'smooth', block: 'start' });
    g.classList.remove('is-hint'); void g.offsetWidth; g.classList.add('is-hint');
    setTimeout(function () { g.classList.remove('is-hint'); }, 1800);
    var b = $('.ty-kcard__add:not(.is-in):not([disabled])', g);
    if (b) setTimeout(function () { try { b.focus({ preventScroll: true }); } catch (x) { b.focus(); } }, REDUZ ? 0 : 500);
  }
  function alternaKit(h) {
    var p = porHandle(h);
    if (!p || !p.av) return;
    var i = KIT.indexOf(h);
    if (i > -1) KIT.splice(i, 1); else KIT.push(h);
    pintaKit();
  }
  function kitNoCarrinho(btn) {
    var itens = KIT.map(porHandle).filter(function (p) { return p && p.av; }).map(function (p) { return { id: Number(p.min.id), quantity: 1 }; });
    if (!itens.length) return;
    var rotulo = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = t('adding'); }
    fetch(cartURL('/cart/add.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: itens })
    })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function () {
        KIT = [];
        if (btn) btn.innerHTML = rotulo;
        pintaKit();
        openCart();
      })
      .catch(function (e) {
        console.error('[tyrrel] kit', e);
        if (btn) { btn.innerHTML = rotulo; btn.disabled = false; }
        toast(t('err_add'));
      });
  }

  /* ==========================================================================
     BANNER — carrossel das 3 fotos de campanha. Troca sozinho a cada 7 s
     (menos com o mouse em cima, com foco dentro, fora da tela ou com
     "reduzir movimento" ligado).
     ========================================================================== */
  var HERO = { i: 0, n: 0, t: null, dur: 7000, pausa: false };
  function heroVai(k, manual) {
    var hero = $('[data-ty-hero]');
    if (!hero) return;
    var slides = $$('[data-ty-slide]', hero);
    HERO.n = slides.length;
    HERO.i = (k + HERO.n) % HERO.n;
    slides.forEach(function (s, i) {
      var on = i === HERO.i;
      s.classList.toggle('is-on', on);
      if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
      $$('a,button', s).forEach(function (a) { if (on) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); });
    });
    var num = $('[data-ty-hero-num]', hero);
    if (num) num.textContent = String(HERO.i + 1);
    heroAgenda(manual);
  }
  function heroAgenda() {
    clearTimeout(HERO.t);
    var bar = $('[data-ty-hero-bar]');
    if (bar) { bar.classList.remove('is-run'); void bar.offsetWidth; }
    if (REDUZ || HERO.pausa || HERO.fora || HERO.n < 2) return;
    if (bar) { bar.style.setProperty('--ty-dur', HERO.dur + 'ms'); bar.classList.add('is-run'); }
    HERO.t = setTimeout(function () { heroVai(HERO.i + 1); }, HERO.dur);
  }
  function ligaHero() {
    var hero = $('[data-ty-hero]');
    if (!hero) return;
    var prev = $('[data-ty-hero-prev]', hero), next = $('[data-ty-hero-next]', hero);
    var rtl = D.documentElement.dir === 'rtl';
    if (prev) prev.addEventListener('click', function () { heroVai(HERO.i - 1, true); });
    if (next) next.addEventListener('click', function () { heroVai(HERO.i + 1, true); });
    hero.addEventListener('mouseenter', function () { HERO.pausa = true; heroAgenda(); });
    hero.addEventListener('mouseleave', function () { HERO.pausa = false; heroAgenda(); });
    hero.addEventListener('focusin', function () { HERO.pausa = true; heroAgenda(); });
    hero.addEventListener('focusout', function () { HERO.pausa = false; heroAgenda(); });
    /* arrastar com o dedo */
    var x0 = null, y0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 == null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
      var ir = dx < 0 ? 1 : -1;
      if (rtl) ir = -ir;
      heroVai(HERO.i + ir, true);
    }, { passive: true });
    /* fora da tela, o banner nao troca sozinho */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        HERO.fora = !es[0].isIntersecting;
        heroAgenda();
      }, { threshold: 0.2 }).observe(hero);
    }
    heroVai(0);
  }

  /* ==========================================================================
     BUSCA — inteira no navegador, sobre o JSON ja baixado (nada de /search,
     que traria outras marcas para dentro da loja da Tyrrel).
     ========================================================================== */
  var buscaEl, buscaVeil, buscaInput, buscaRes, buscaSug, buscaNone, buscaT;
  function normal(s) {
    s = String(s == null ? '' : s).toLowerCase();
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) { /* motor antigo */ }
    return s;
  }
  function buscar(q) {
    var n = normal(q).trim();
    if (n.length < 2) return [];
    var termos = n.split(/\s+/);
    return PRODUCTS.filter(function (p) {
      /* o handle entra na busca: e em ingles e nao muda com o idioma */
      var alvo = normal(p.t) + ' ' + normal(curto(p)) + ' ' + normal(p.h.replace(/-/g, ' ')) + ' ' + normal(p.tags.join(' ')) + ' ' +
                 normal(p.v.map(function (v) { return v.sku || ''; }).join(' '));
      return termos.every(function (x) { return alvo.indexOf(x) > -1; });
    }).slice(0, 40);
  }
  function sresHTML(p) {
    var img = (p.img[0] || {}).s || '';
    return '<button type="button" class="ty-sres" data-ty-open-handle="' + esc(p.h) + '">' +
      '<span class="ty-sres__img">' + (img ? '<img src="' + esc(imgW(img, 120)) + '" alt="" loading="lazy">' : '') + '</span>' +
      '<span><b>' + esc(curto(p)) + '</b><span>' + precoHTML(p).replace(/<\/?b>/g, '') + '</span></span></button>';
  }
  function montaPopulares() {
    var alvo = $('[data-ty-search-popular]');
    if (!alvo) return;
    alvo.innerHTML = daLista(CFG.best).filter(function (p) { return p.av; }).slice(0, 5).map(sresHTML).join('');
  }
  function pintaResultados(q) {
    if (!buscaRes) return;
    var lista = buscar(q);
    var temTermo = normal(q).trim().length >= 2;
    if (buscaSug) buscaSug.hidden = temTermo;
    buscaRes.hidden = !temTermo;
    if (buscaNone) buscaNone.hidden = !(temTermo && !lista.length);
    buscaRes.innerHTML = lista.map(sresHTML).join('');
  }
  function abrirBusca(termo) {
    if (!buscaEl) return;
    fecharMenu();
    if (termo != null && buscaInput) { buscaInput.value = termo; pintaResultados(termo); }
    if (buscaEl.classList.contains('is-on')) return;
    lastFocus = D.activeElement;
    buscaEl.classList.add('is-on');
    buscaEl.setAttribute('aria-hidden', 'false');
    if (buscaVeil) { buscaVeil.hidden = false; requestAnimationFrame(function () { buscaVeil.classList.add('is-on'); }); }
    travarRolagem();
    if (buscaInput) setTimeout(function () { buscaInput.focus(); }, 60);
  }
  function fecharBusca() {
    if (!buscaEl || !buscaEl.classList.contains('is-on')) return;
    buscaEl.classList.remove('is-on');
    buscaEl.setAttribute('aria-hidden', 'true');
    if (buscaVeil) { buscaVeil.classList.remove('is-on'); setTimeout(function () { buscaVeil.hidden = true; }, 220); }
    destravarRolagem();
  }
  function ligaBusca() {
    buscaEl = $('[data-ty-search]');
    buscaVeil = $('[data-ty-search-veil]');
    buscaInput = $('[data-ty-search-input]');
    buscaRes = $('[data-ty-search-results]');
    buscaSug = $('[data-ty-search-suggest]');
    buscaNone = $('[data-ty-search-none]');
    if (!buscaEl || !buscaInput) return;
    buscaInput.addEventListener('input', function () {
      clearTimeout(buscaT);
      var v = buscaInput.value;
      buscaT = setTimeout(function () { pintaResultados(v); }, 120);
    });
    buscaInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); clearTimeout(buscaT); pintaResultados(buscaInput.value); }
    });
  }

  /* ---------- menu do celular ------------------------------------------------------- */
  var menuEl, menuVeil;
  function abrirMenu() {
    if (!menuEl || menuEl.classList.contains('is-on')) return;
    lastFocus = D.activeElement;
    menuEl.classList.add('is-on');
    menuEl.setAttribute('aria-hidden', 'false');
    if (menuVeil) { menuVeil.hidden = false; requestAnimationFrame(function () { menuVeil.classList.add('is-on'); }); }
    travarRolagem();
    var x = $('[data-ty-menu-close]', menuEl);
    if (x) x.focus();
  }
  function fecharMenu() {
    if (!menuEl || !menuEl.classList.contains('is-on')) return;
    menuEl.classList.remove('is-on');
    menuEl.setAttribute('aria-hidden', 'true');
    if (menuVeil) { menuVeil.classList.remove('is-on'); setTimeout(function () { menuVeil.hidden = true; }, 220); }
    destravarRolagem();
  }

  /* ---------- cabecalho: grudado no topo (CSS sticky); o JS mede a altura -------------- */
  function ligaCabecalho() {
    var head = $('[data-ty-head]');
    if (!head) return;
    function mede() {
      D.body.style.setProperty('--ty-hh', Math.round(head.getBoundingClientRect().height) + 'px');
      encaixa();
    }
    /* O logo fica no centro; se o menu ou as ferramentas encostarem nele
       (idioma de palavras longas), tira o que e dispensavel, um de cada vez. */
    function encaixa() {
      var marca = $('.ty-brand', head), tools = $('.ty-head__tools', head), nav = $('.ty-nav', head);
      if (!marca || !tools) return;
      head.classList.remove('t1', 't2', 't3');
      var rtl = D.documentElement.dir === 'rtl';
      function bate() {
        var m = marca.getBoundingClientRect(), t = tools.getBoundingClientRect();
        var n = nav && nav.offsetParent ? nav.getBoundingClientRect() : null;
        var folga = 14;
        var toolsBate = rtl ? (t.right > m.left - folga) : (t.left < m.right + folga);
        var navBate = n ? (rtl ? (n.left < m.right + folga) : (n.right > m.left - folga)) : false;
        return toolsBate || navBate;
      }
      ['t1', 't2', 't3'].forEach(function (c) { if (bate()) head.classList.add(c); });
    }
    mede();
    window.addEventListener('resize', mede);
    if (D.fonts && D.fonts.ready) D.fonts.ready.then(mede);
    /* sombra leve so depois que a pagina rolou */
    var pedido = false;
    window.addEventListener('scroll', function () {
      if (pedido) return;
      pedido = true;
      requestAnimationFrame(function () { pedido = false; head.classList.toggle('is-scrolled', window.scrollY > 8); });
    }, { passive: true });
  }

  /* ---------- paginas 2..N ----------------------------------------------------------
     Pelo ?view=tyrrel-data, que devolve SO o JSON. Tres tentativas com pausa
     crescente: um 502 do proprio Shopify ja tirou metade da vitrine da Prohall. */
  function buscaPagina(n, tentativa) {
    var url = (CFG.root || '') + '/pages/' + encodeURIComponent(CFG.page || 'tyrrel-professional') + '?view=tyrrel-data&page=' + n;
    /* SEM "Accept: application/json": com esse cabecalho a Shopify ignora o
       ?view= e devolve o JSON nativo da pagina (medido na Gold Spell). */
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (txt) {
        var j = JSON.parse(txt);
        if (!j || !j.products || !j.products.length) throw new Error('pagina vazia');
        return j.products;
      })
      .catch(function (err) {
        if (tentativa >= 3) { console.warn('[tyrrel] pagina ' + n + ' nao veio:', err.message); return []; }
        return new Promise(function (ok) { setTimeout(ok, 400 * tentativa); }).then(function () { return buscaPagina(n, tentativa + 1); });
      });
  }
  function carregarResto() {
    var total = Number(CFG.pages) || 1;
    if (total < 2 || !PRODUCTS.length) return Promise.resolve();
    var pedidos = [];
    for (var n = 2; n <= total; n++) pedidos.push(buscaPagina(n, 1));
    return Promise.all(pedidos).then(function (partes) {
      var vistos = {};
      PRODUCTS.forEach(function (p) { vistos[p.h] = true; });
      var novos = [];
      partes.forEach(function (lista) { lista.forEach(function (p) { if (p && p.h && !vistos[p.h]) { vistos[p.h] = true; novos.push(p); } }); });
      if (!novos.length) return;
      PRODUCTS = PRODUCTS.concat(prepara(novos));
      renderGrids();
      pintaKit();
    });
  }

  /* ---------- trava de rolagem ---------------------------------------------------------
     Trava o HTML e o body: com html{overflow-x:clip}, travar so o body deixava
     a roda do mouse rolar a LP por tras do popup (armadilha da Peach Up). */
  var travas = 0;
  function travarRolagem() { travas++; D.documentElement.classList.add('ty-lock'); D.body.classList.add('ty-lock'); }
  function destravarRolagem() {
    travas = Math.max(0, travas - 1);
    if (!travas) { D.documentElement.classList.remove('ty-lock'); D.body.classList.remove('ty-lock'); }
  }

  /* ---------- ficha do produto ---------------------------------------------------------- */
  var pdpOvl, pdpBox, lastFocus = null;
  var PDP = { p: null, v: null };
  var INFO = {};

  function linhas(txt) { return String(txt || '').split('\n').map(function (l) { return l.trim(); }).filter(Boolean); }
  function bulletsHTML(txt) {
    var ls = linhas(txt);
    if (!ls.length) return '';
    return ls.length > 1 ? '<ul>' + ls.map(function (l) { return '<li>' + esc(l.replace(/^[-•]\s*/, '')) + '</li>'; }).join('') + '</ul>' : '<p>' + esc(ls[0]) + '</p>';
  }
  function parasHTML(txt) {
    if (!txt) return '';
    return String(txt).split(/\n{2,}|\n---\n/).map(function (b) {
      var l = b.trim();
      return l ? '<p>' + esc(l).replace(/\n/g, '<br>') + '</p>' : '';
    }).join('');
  }
  /* "Ingredientes explicados": blocos separados por ---, NOME na primeira
     linha; linha comecando com ⚠ e aviso e ganha destaque proprio. */
  function ingHTML(txt) {
    if (!txt) return '';
    return String(txt).split(/\n?---\n?/).map(function (bloco) {
      var ls = linhas(bloco);
      if (!ls.length) return '';
      var nome = ls.shift();
      var aviso = ls.filter(function (x) { return /^⚠/.test(x); });
      var corpo = ls.filter(function (x) { return !/^⚠/.test(x); });
      return '<div class="ty-ing"><strong>' + esc(nome) + '</strong>' + esc(corpo.join(' ')) +
        (aviso.length ? '<span class="ty-warn">' + esc(aviso.join(' ')) + '</span>' : '') + '</div>';
    }).join('');
  }
  function acc(key, body, open) {
    if (!body) return '';
    return '<details class="ty-acc"' + (open ? ' open' : '') + '><summary>' + esc(t(key)) + '</summary><div class="ty-acc__c">' + body + '</div></details>';
  }
  function qdHTML() {
    var passos = CFG.steps || [];
    if (!passos.length) return '';
    return '<div class="ty-pdp__qd" data-ty-pdp-qd><strong>' + esc(t('qd_t')) + '</strong><ul>' +
      passos.map(function (s) {
        return '<li data-q="' + s.q + '"><b>' + s.p + '%</b><span>' + esc(s.q >= 4 ? t('qd_4') : t('qd_' + s.q)) + '</span></li>';
      }).join('') + '</ul><small>' + esc(t('qd_d')) + ' ' + esc(t('qd_note')) + '</small></div>';
  }
  function optHTML(p) {
    if (!p.multi) return '';
    var rotulo = p.opt && p.opt !== 'Title' ? p.opt : t('pdp_opt');
    return '<div class="ty-opt"><span class="ty-opt__l" id="ty-opt-l">' + esc(rotulo) + '</span>' +
      '<div class="ty-opt__list" role="group" aria-labelledby="ty-opt-l">' +
      p.v.map(function (v) {
        return '<button type="button" class="ty-opt__b" data-ty-var="' + v.id + '" aria-pressed="' + (PDP.v && PDP.v.id === v.id) + '"' +
          (v.av ? '' : ' disabled') + '>' + esc(v.t) + '</button>';
      }).join('') + '</div></div>';
  }
  function pintarVariante() {
    var p = PDP.p, v = PDP.v;
    if (!p || !v) return;
    var preco = $('[data-ty-pdp-price]');
    if (preco) preco.innerHTML = (v.cmpf ? '<s>' + esc(v.cmpf) + '</s>' : '') + '<b>' + esc(v.prf) + '</b>';
    var bdg = $('[data-ty-pdp-badges]');
    if (bdg) bdg.innerHTML = badgesHTML(p, v);
    var sku = $('[data-ty-pdp-sku]');
    if (sku) { sku.textContent = t('pdp_sku') + ': ' + (v.sku || '—'); sku.hidden = !v.sku; }
    $$('[data-ty-var]').forEach(function (b) { b.setAttribute('aria-pressed', String(Number(b.dataset.tyVar) === Number(v.id))); });
    $$('[data-ty-add],[data-ty-buy]', pdpBox).forEach(function (b) {
      var ehAdd = b.hasAttribute('data-ty-add');
      if (ehAdd) b.dataset.tyAdd = v.id; else b.dataset.tyBuy = v.id;
      b.disabled = !v.av;
      b.textContent = v.av ? (ehAdd ? t('add') : t('buy')) : t('soldout');
    });
    var qty = $('.ty-pdp__qty');
    if (qty) qty.hidden = !v.av;
    marcarDegrausPDP();
  }

  var PDP_QTD_MAX = 10;
  function qtdHTML() {
    return '<div class="ty-pdp__qty"><span class="ty-pdp__qty-l" id="ty-pdp-qty-l">' + esc(t('pdp_qty')) + '</span>' +
      '<span class="ty-step ty-step--lg" role="group" aria-labelledby="ty-pdp-qty-l">' +
      '<button type="button" data-ty-pdp-step="-1" aria-label="' + esc(t('c_less')) + '" disabled>&minus;</button>' +
      '<span data-ty-pdp-qtd aria-live="polite">1</span>' +
      '<button type="button" data-ty-pdp-step="1" aria-label="' + esc(t('c_more')) + '">+</button></span></div>';
  }
  function pdpQtd() {
    var el = $('[data-ty-pdp-qtd]');
    var n = el ? parseInt(el.textContent, 10) : 1;
    return (isFinite(n) && n > 0) ? Math.min(PDP_QTD_MAX, n) : 1;
  }
  function porQtdPDP(n) {
    var el = $('[data-ty-pdp-qtd]');
    if (!el) return;
    n = Math.min(PDP_QTD_MAX, Math.max(1, n));
    el.textContent = String(n);
    var menos = $('[data-ty-pdp-step="-1"]'), mais = $('[data-ty-pdp-step="1"]');
    if (menos) menos.disabled = n <= 1;
    if (mais) mais.disabled = n >= PDP_QTD_MAX;
    marcarDegrausPDP();
  }
  /* O Pumper conta o carrinho INTEIRO: acende o degrau do que o carrinho VAI
     ter depois de somar a quantidade escolhida aqui. */
  function marcarDegrausPDP() {
    var caixa = $('[data-ty-pdp-qd]');
    if (!caixa) return;
    var at = degrauDe(CART.count + pdpQtd());
    $$('li', caixa).forEach(function (li) { li.classList.toggle('is-on', !!at && Number(li.dataset.q) === at.q); });
  }
  /* O que abre o popup da garantia, de qualquer lugar: <label for>, nunca um
     link para outra guia (quem sai da LP perde o carrinho de vista). */
  function abreGarantia(rotulo) {
    return '<label class="ty-lnk" for="ty-guar-cbx" role="button" tabindex="0">' + esc(t(rotulo)) + '</label>';
  }
  function entregaHTML() {
    return '<div class="ty-pdp__del">' + SELO + '<div><b>' + esc(t('del_t')) + '</b><p>' + esc(t('del_pdp')) + '</p>' + abreGarantia('del_c') + '</div></div>';
  }
  /* A parte pesada da ficha: descricao completa + resumo por IA, pelo
     ?view=tyrrel-info. Se falhar, cai para o /products/<h>.js. */
  function carregaInfo(h) {
    if (INFO[h]) return Promise.resolve(INFO[h]);
    var base = (CFG.root || '') + '/products/' + encodeURIComponent(h);
    return fetch(base + '?view=tyrrel-info', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (txt) { return JSON.parse(txt); })
      .catch(function () {
        return fetch(base + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (j) { return { ai: {}, d: j.description || '' }; });
      })
      .then(function (info) { INFO[h] = info || { ai: {}, d: '' }; return INFO[h]; })
      .catch(function () { return { ai: {}, d: '' }; });
  }
  function pintaInfo(p, info) {
    var alvo = $('[data-ty-pdp-more]');
    if (!alvo || !PDP.p || PDP.p.h !== p.h) return;
    var ai = info.ai || {};
    var tag = $('[data-ty-pdp-tag]');
    if (tag) { tag.textContent = ai.tag || ''; tag.hidden = !ai.tag; }
    alvo.innerHTML =
      acc('pdp_purpose', bulletsHTML(ai.pur), true) +
      acc('pdp_high', bulletsHTML(ai.hig)) +
      acc('pdp_how', parasHTML(ai.how)) +
      acc('pdp_audience', parasHTML(ai.aud)) +
      acc('pdp_good', bulletsHTML(ai.gtk)) +
      acc('pdp_ing', ingHTML(ai.ing)) +
      acc('pdp_tog', parasHTML(ai.tog)) +
      (info.d ? '<details class="ty-acc"' + (ai.pur ? '' : ' open') + '><summary>' + esc(t('pdp_desc')) + '</summary><div class="ty-acc__c ty-desc">' + info.d + '</div></details>' : '') +
      (info.note ? '<p class="ty-legal">' + esc(info.note) + '</p>' : '');
  }
  function openPDP(handle) {
    var p = porHandle(handle);
    if (!p || !pdpOvl) return false;
    fecharMenu();
    if (!pdpOvl.classList.contains('is-on')) lastFocus = D.activeElement;
    PDP.p = p;
    PDP.v = p.min; /* abre na variante disponivel mais barata, nunca numa esgotada */
    var thumbs = p.img.map(function (im, i) {
      return '<button type="button" data-ty-th="' + i + '"' + (i === 0 ? ' aria-current="true"' : '') + ' aria-label="' + (i + 1) + '/' + p.img.length + '">' +
        '<img src="' + esc(imgW(im.s, 120)) + '" alt="" loading="lazy"></button>';
    }).join('');
    var im0 = p.img[0] || {};
    pdpBox.innerHTML =
      '<button type="button" class="ty-x" data-ty-pdp-close aria-label="' + esc(t('pdp_close')) + '">&times;</button>' +
      '<div class="ty-pdp">' +
        '<div class="ty-pdp__gal">' +
          '<div class="ty-pdp__main">' + (im0.s ? '<img src="' + esc(imgW(im0.s, 900)) + '" alt="' + esc(im0.a || p.t) + '" width="900" height="900" data-ty-main>' : '') + '</div>' +
          (p.img.length > 1 ? '<div class="ty-pdp__thumbs">' + thumbs + '</div>' : '') +
        '</div>' +
        '<div class="ty-pdp__info">' +
          '<p class="ty-pdp__brand">Tyrrel Professional · ' + esc(t('official')) + '</p>' +
          '<h2 id="ty-pdp-t">' + esc(p.t) + '</h2>' +
          starsHTML(p) +
          '<p class="ty-pdp__tag" data-ty-pdp-tag hidden></p>' +
          '<div class="ty-pdp__badges" data-ty-pdp-badges></div>' +
          '<div class="ty-pdp__price" data-ty-pdp-price></div>' +
          optHTML(p) + qtdHTML() + qdHTML() +
          '<div class="ty-pdp__acts">' +
            '<button type="button" class="ty-btn ty-btn--ghost" data-ty-add=""></button>' +
            '<button type="button" class="ty-btn" data-ty-buy=""></button>' +
          '</div>' +
          entregaHTML() +
          '<div data-ty-pdp-more><div class="ty-skel" aria-hidden="true"><i></i><i></i><i></i></div></div>' +
          '<p class="ty-nota" style="margin:0" data-ty-pdp-sku></p>' +
        '</div>' +
      '</div>';
    if (!pdpOvl.classList.contains('is-on')) { pdpOvl.classList.add('is-on'); travarRolagem(); }
    pdpOvl.scrollTop = 0; pdpBox.scrollTop = 0;
    porQtdPDP(1);
    pintarVariante();
    var x = $('[data-ty-pdp-close]', pdpBox);
    if (x) x.focus();
    carregaInfo(p.h).then(function (info) { pintaInfo(p, info); });
    return true;
  }
  function closePDP() {
    if (!pdpOvl || !pdpOvl.classList.contains('is-on')) return;
    pdpOvl.classList.remove('is-on');
    destravarRolagem();
    pdpBox.innerHTML = '';
    PDP.p = null; PDP.v = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- carrinho ------------------------------------------------------------------- */
  var CART = { items: [], total: 0, count: Number((CFG.cart || {}).count) || 0, raw: null };
  var cartEl, veilEl, bodyEl, footEl, totalEl, countEl, qdEl, shipEl;

  /* Recado de frete CALCULADO por window.MKPBR_SHIP (a mesma conta da barra
     da loja) e escrito dentro do carrinho. */
  function espelharFrete() {
    if (!shipEl) return;
    var S = window.MKPBR_SHIP;
    if (!S || typeof S.compute !== 'function' || !CART.raw || CART.count < 1) { shipEl.hidden = true; return; }
    var e;
    try { e = S.compute(CART.raw); } catch (err) { console.error('[tyrrel] frete', err); shipEl.hidden = true; return; }
    if (!e) { shipEl.hidden = true; return; }
    if (e.freeReached) shipEl.innerHTML = '<b>' + esc(t('ship_free')) + '</b>';
    else if (e.faltaProximo > 0 && e.economiaProximo > 0) {
      shipEl.innerHTML = '<b>' + esc(t('ship_more').replace('{v}', money(Math.round(e.faltaProximo * 100))).replace('{p}', money(Math.round(e.economiaProximo * 100)))) + '</b>';
    } else { shipEl.hidden = true; return; }
    shipEl.hidden = false;
  }
  function cartURL(path) { return (CFG.root || '') + path; }
  function aplicarCarrinho(c) {
    if (!c) return;
    CART.items = c.items || [];
    CART.total = c.total_price || 0;
    CART.count = c.item_count || 0;
    CART.raw = c;
    if (c.currency) CURRENCY = c.currency;
    syncCart();
  }
  function fetchCart() {
    return fetch(cartURL('/cart.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { aplicarCarrinho(c); return c; })
      .catch(function (e) { console.error('[tyrrel] cart.js', e); });
  }
  function syncCart() {
    if (countEl) countEl.textContent = CART.count;
    /* a barra de frete da loja so aparece DEPOIS que existe carrinho */
    D.body.classList.toggle('ty-has-cart', CART.count > 0);
    renderCart();
    markStep();
    pintaKit();
  }
  function renderCart() {
    if (!bodyEl) return;
    if (!CART.items.length) {
      bodyEl.innerHTML = '<div class="ty-cart__empty"><strong>' + esc(t('c_empty')) + '</strong><span>' + esc(t('c_empty_d')) + '</span>' +
        '<button type="button" class="ty-btn ty-btn--ghost ty-btn--sm" data-ty-cart-close>' + esc(t('c_empty_cta')) + '</button></div>';
      if (footEl) footEl.hidden = true;
      return;
    }
    bodyEl.innerHTML = CART.items.map(function (it) {
      var img = it.image ? imgW(it.image, 160) : '';
      var vt = (it.variant_title && it.variant_title !== 'Default Title') ? '<span class="ty-line__v">' + esc(it.variant_title) + '</span>' : '';
      return '<div class="ty-line" data-key="' + esc(it.key) + '">' +
        '<div class="ty-line__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div><span class="ty-line__t">' + esc(curtoLinha(it)) + '</span>' + vt +
          '<div class="ty-line__r"><span class="ty-step">' +
            '<button type="button" data-ty-qty="-1" aria-label="' + esc(t('c_less')) + '">&minus;</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-ty-qty="1" aria-label="' + esc(t('c_more')) + '">+</button></span>' +
            '<span class="ty-line__p">' + money(it.final_line_price != null ? it.final_line_price : it.line_price) + '</span></div>' +
          '<button type="button" class="ty-line__x" data-ty-rm>' + esc(t('c_rm')) + '</button>' +
        '</div></div>';
    }).join('');
    if (footEl) footEl.hidden = false;
    if (totalEl) totalEl.textContent = money(CART.total);
  }
  function markStep() {
    var at = degrauDe(CART.count);
    marcarDegrausPDP();
    if (qdEl) {
      if (at) {
        qdEl.textContent = (at.q >= 4 ? t('qd_4') : t('qd_' + at.q)) + ' · ' + at.p + '% ' + t('off') + ' — ' + t('qd_note');
        qdEl.hidden = false;
      } else qdEl.hidden = true;
    }
    espelharFrete();
  }
  function openCart() {
    if (!cartEl || cartEl.classList.contains('is-on')) return;
    fecharMenu();
    lastFocus = D.activeElement;
    cartEl.classList.add('is-on');
    cartEl.setAttribute('aria-hidden', 'false');
    if (veilEl) { veilEl.hidden = false; requestAnimationFrame(function () { veilEl.classList.add('is-on'); }); }
    travarRolagem();
    espelharFrete();
    var c = $('[data-ty-cart-close]', cartEl);
    if (c) c.focus();
  }
  function closeCart() {
    if (!cartEl || !cartEl.classList.contains('is-on')) return;
    cartEl.classList.remove('is-on');
    cartEl.setAttribute('aria-hidden', 'true');
    if (veilEl) { veilEl.classList.remove('is-on'); setTimeout(function () { veilEl.hidden = true; }, 220); }
    destravarRolagem();
    if (lastFocus && lastFocus.focus && !pdpOvl.classList.contains('is-on')) lastFocus.focus();
  }

  var toastT;
  function toast(msg) {
    var el = $('[data-ty-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }
  function addToCart(vid, abrir, btn, qtd) {
    if (!vid) return;
    var q = Math.min(PDP_QTD_MAX, Math.max(1, Number(qtd) || 1));
    var redondo = btn && btn.classList.contains('ty-card__add');
    var rotulo = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; if (redondo) btn.classList.add('is-busy'); else btn.textContent = t('adding'); }
    return fetch(cartURL('/cart/add.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: q }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function () {
        if (btn) {
          btn.disabled = false;
          if (redondo) { btn.classList.remove('is-busy'); btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); }, 1400); }
          else { btn.textContent = t('added'); setTimeout(function () { btn.innerHTML = rotulo; }, 1400); }
        }
        porQtdPDP(1);
        /* card e "adicionar" NAO abrem o carrinho; "comprar agora" abre */
        if (abrir) { closePDP(); openCart(); } else toast(t('toast_added'));
      })
      .catch(function (e) {
        console.error('[tyrrel] add', e);
        if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); btn.innerHTML = rotulo; }
        toast(t('err_add'));
      });
  }
  function changeQty(key, qty) {
    return fetch(cartURL('/cart/change.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); }).then(aplicarCarrinho)
      .catch(function (e) { console.error('[tyrrel] change', e); });
  }

  /* ---------- seletores de pais e idioma ---------------------------------------------- */
  function bindPicker(wrap) {
    if (!wrap) return;
    var btn = $('.ty-pick__btn', wrap), menu = $('.ty-pick__menu', wrap);
    if (!btn || !menu) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var aberto = !menu.hidden;
      fecharMenus();
      if (aberto) return;
      menu.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      var atual = $('[aria-current="true"]', menu);
      if (atual) atual.scrollIntoView({ block: 'nearest' });
    });
    menu.addEventListener('click', function (e) { e.stopPropagation(); });
  }
  function fecharMenus() {
    $$('.ty-pick__menu').forEach(function (m) { m.hidden = true; });
    $$('.ty-pick__btn').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  /* O pais prefere a janela do app Orbe; a lista nativa fica de reserva.
     mdApp_forceHideOrbe so trava o pop-up AUTOMATICO. */
  function tentarOrbe() {
    try {
      var modal = D.getElementById('md-app-embed__footer-popup');
      if (typeof window.mdApp_openModal === 'function' && modal) { window.mdApp_openModal('md-app-embed__footer-popup'); return true; }
      if (window.mdApp && typeof window.mdApp.openModal === 'function') { window.mdApp.openModal(); return true; }
    } catch (e) { /* segue para a lista nativa */ }
    return false;
  }
  function abrirPais() {
    if (tentarOrbe()) return;
    var btn = $('[data-ty-country] .ty-pick__btn');
    if (btn) { window.scrollTo(0, 0); btn.click(); }
  }

  /* ---------- dominio proprio da marca (subdominio servido por proxy) -------------------
     Herdado da Popozuda (popozuda.mkpbr.com). A Tyrrel hoje NAO tem subdominio:
     no dominio principal nada disto liga (foraDoPrincipal() = false). Fica
     pronto para o dia em que tiver.
     A LP tambem abre por um subdominio servido por um proxy (Cloudflare Worker)
     na frente do Shopify. Em 20/09/2026 o proxy da Popozuda SEGUIA sozinho os
     redirecionamentos (302) em vez de entrega-los ao navegador: o checkout
     abria dentro do subdominio e dava "There was a problem with our checkout",
     e trocar pais/idioma dava "Proxy error". (Os proxies das outras marcas
     entregam o 302 e funcionam.)
     A LP testa o proxy UMA vez por visita, pedindo /checkout sem cookies e sem
     seguir redirecionamento: proxy certo devolve um redirecionamento; proxy
     quebrado devolve 200. So no segundo caso ela contorna:
       - pagar: vai para o link de carrinho do DOMINIO PRINCIPAL
         (https://mkpbr.com/<mercado>/cart/<id>:<qtd>,...), que abre o checkout
         com os mesmos itens — o Pumper aplica o desconto la (conferido:
         3 itens, US$ 107,16 -> US$ 96,47);
       - pais/idioma: os formularios (da LP e da janela do Orbe) passam a postar
         no dominio principal, e a pessoa volta para a LP em mkpbr.com.
     No dominio principal e com o proxy certo, nada disso liga. */
  function foraDoPrincipal() {
    var p = String(CFG.primary || '').toLowerCase(), h = String(location.hostname || '').toLowerCase();
    return !!p && h !== p && h !== 'www.' + p;
  }
  var proxyP = null;
  function testaProxy() {
    if (!foraDoPrincipal()) return Promise.resolve(true);
    if (proxyP) return proxyP;
    var memo = null;
    try { memo = sessionStorage.getItem('ty-proxy'); } catch (e) { /* sem memoria */ }
    if (memo === '1' || memo === '0') proxyP = Promise.resolve(memo === '1');
    else proxyP = fetch((CFG.root || '') + '/checkout', { redirect: 'manual', credentials: 'omit', cache: 'no-store' })
      .then(function (r) { return r.type === 'opaqueredirect' || (r.status >= 300 && r.status < 400); })
      .catch(function () { return true; })  /* sem resposta: segue o caminho normal */
      .then(function (ok) { try { sessionStorage.setItem('ty-proxy', ok ? '1' : '0'); } catch (e) { /* so nesta pagina */ } return ok; });
    proxyP.then(function (ok) { if (!ok) formsNoPrincipal(); });
    return proxyP;
  }
  function formsNoPrincipal() {
    var base = 'https://' + CFG.primary;
    $$('form[action$="/localization"]').forEach(function (f) {
      var a = f.getAttribute('action') || '';
      if (a.charAt(0) === '/') f.setAttribute('action', base + a);
    });
    /* A janela do Orbe envia o formulario por form.submit() (sem evento) e poe
       em return_to o caminho ATUAL: no subdominio isso e "/en-fr", a raiz — que
       no dominio principal e a home da loja, nao a LP. Aqui o retorno de raiz
       vira /<mercado>/pages/<esta pagina>. So liga com o proxy quebrado. */
    if (!HTMLFormElement.prototype.__tyEnvia) {
      var envia = HTMLFormElement.prototype.submit;
      HTMLFormElement.prototype.__tyEnvia = envia;
      HTMLFormElement.prototype.submit = function () {
        try { if (/\/localization$/.test(this.getAttribute('action') || '')) retornoNaLP(this); } catch (e) { /* segue */ }
        return envia.call(this);
      };
    }
  }
  function retornoNaLP(f) {
    var rt = f.querySelector('input[name="return_to"]');
    if (!rt || !CFG.page) return;
    var m = String(rt.value || '/').match(/^(\/[a-z]{2}(?:-[a-z0-9]{2,4})?)?\/?(\?.*)?$/i);
    if (m) rt.value = (m[1] || '') + '/pages/' + CFG.page + (m[2] || '');
  }
  function irPagar(link) {
    var href = link.href;
    link.setAttribute('aria-busy', 'true');
    testaProxy().then(function (ok) {
      if (ok) { location.href = href; return; }
      return fetch((CFG.root || '') + '/cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var itens = (c.items || []).map(function (i) { return i.variant_id + ':' + i.quantity; });
          location.href = itens.length ? 'https://' + CFG.primary + (CFG.root || '') + '/cart/' + itens.join(',') : href;
        });
    }).catch(function () { location.href = href; });
  }

  /* ---------- faixa de divergencia de mercado --------------------------------------------
     Sinal: regiao do idioma do navegador; na falta, o fuso. SEM SINAL, NAO
     APARECE. So na divergencia — nunca um pop-up em todo acesso. */
  var TZ2CC = {
    'America/New_York': 'US', 'America/Chicago': 'US', 'America/Denver': 'US', 'America/Los_Angeles': 'US',
    'America/Toronto': 'CA', 'America/Vancouver': 'CA', 'Europe/London': 'GB', 'Europe/Dublin': 'IE',
    'Europe/Lisbon': 'PT', 'Europe/Madrid': 'ES', 'Europe/Paris': 'FR', 'Europe/Berlin': 'DE',
    'Europe/Rome': 'IT', 'Europe/Amsterdam': 'NL', 'Europe/Brussels': 'BE', 'Europe/Zurich': 'CH',
    'Europe/Vienna': 'AT', 'Europe/Stockholm': 'SE', 'Europe/Oslo': 'NO', 'Europe/Copenhagen': 'DK',
    'Asia/Tokyo': 'JP', 'Asia/Seoul': 'KR', 'Asia/Dubai': 'AE', 'Asia/Riyadh': 'SA', 'Asia/Jerusalem': 'IL',
    'Asia/Qatar': 'QA', 'Asia/Kuwait': 'KW', 'Asia/Bahrain': 'BH', 'Asia/Muscat': 'OM',
    'Australia/Sydney': 'AU', 'Australia/Melbourne': 'AU', 'Pacific/Auckland': 'NZ'
  };
  function paisDoNavegador() {
    var langs = navigator.languages || [navigator.language];
    for (var i = 0; i < langs.length; i++) {
      var m = /[-_]([A-Za-z]{2})$/.exec(langs[i] || '');
      if (m) return m[1].toUpperCase();
    }
    try { var tz = Intl.DateTimeFormat().resolvedOptions().timeZone; if (tz && TZ2CC[tz]) return TZ2CC[tz]; } catch (e) { /* sem sinal */ }
    return null;
  }
  function marketHint() {
    var barra = $('[data-ty-hint]');
    if (!barra) return;
    try { if (sessionStorage.getItem('ty-hint-off') === '1') return; } catch (e) { /* segue */ }
    var atual = String(CFG.country || '').toUpperCase();
    var sinal = paisDoNavegador();
    if (!sinal || !atual || sinal === atual) return;
    var form = D.getElementById('ty-country-form');
    var alvo = form ? $('button[value="' + sinal + '"]', form) : null;
    if (!alvo) return; /* a loja nao vende para esse pais: nao oferece nada */
    var nome = $('span', alvo);
    var nomeEl = $('[data-ty-hint-name]', barra);
    if (nomeEl) nomeEl.textContent = nome ? nome.textContent : sinal;
    var ir = $('[data-ty-hint-go]', barra);
    if (ir) ir.addEventListener('click', function (e) { e.preventDefault(); alvo.click(); });
    var x = $('[data-ty-hint-x]', barra);
    if (x) x.addEventListener('click', function () {
      barra.classList.remove('is-on');
      try { sessionStorage.setItem('ty-hint-off', '1'); } catch (e) { /* so nesta visita */ }
    });
    barra.classList.add('is-on');
  }

  /* ---------- ligacao ----------------------------------------------------------------------- */
  function init() {
    $$('[data-ty-grid]').forEach(function (g) { g.setAttribute('aria-busy', 'true'); });

    cartEl = $('[data-ty-cart]'); veilEl = $('[data-ty-cart-veil]'); bodyEl = $('[data-ty-cart-body]');
    footEl = $('[data-ty-cart-foot]'); totalEl = $('[data-ty-cart-total]'); countEl = $('[data-ty-count]');
    qdEl = $('[data-ty-cart-qd]'); shipEl = $('[data-ty-cart-ship]');
    pdpOvl = $('[data-ty-pdp-ovl]'); pdpBox = $('[data-ty-pdp]');
    menuEl = $('[data-ty-menu]'); menuVeil = $('[data-ty-menu-veil]');

    ligaCabecalho();
    ligaHero();
    ligaBusca();
    ligaAbas();
    renderGrids();
    pintaKit();
    bindPicker($('[data-ty-lang]'));
    bindPicker($('[data-ty-country]'));
    D.body.classList.toggle('ty-has-cart', CART.count > 0);

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { $$('.ty-rail').forEach(atualizaRail); }, 150);
    });

    var btnPais = $('[data-ty-country] .ty-pick__btn');
    if (btnPais) btnPais.addEventListener('click', function (e) {
      if (tentarOrbe()) { e.stopImmediatePropagation(); fecharMenus(); }
    }, true);

    D.addEventListener('click', fecharMenus);

    /* Clique global. A ORDEM importa: controles internos da ficha, depois
       botoes de compra, depois o card (que tambem responde ao clique). */
    D.addEventListener('click', function (e) {
      var alvo = e.target;
      if (!alvo || !alvo.closest) return;

      var opt = alvo.closest('[data-ty-var]');
      if (opt) {
        e.preventDefault(); e.stopPropagation();
        if (opt.disabled || !PDP.p) return;
        var nova = PDP.p.v.filter(function (v) { return Number(v.id) === Number(opt.dataset.tyVar); })[0];
        if (nova) { PDP.v = nova; pintarVariante(); }
        return;
      }
      var passo = alvo.closest('[data-ty-pdp-step]');
      if (passo) { e.preventDefault(); e.stopPropagation(); porQtdPDP(pdpQtd() + Number(passo.dataset.tyPdpStep)); return; }

      var add = alvo.closest('[data-ty-add]');
      if (add) { e.preventDefault(); e.stopPropagation(); addToCart(add.dataset.tyAdd, false, add, add.closest('.ty-pdp') ? pdpQtd() : 1); return; }
      var buy = alvo.closest('[data-ty-buy]');
      if (buy) { e.preventDefault(); e.stopPropagation(); addToCart(buy.dataset.tyBuy, true, buy, buy.closest('.ty-pdp') ? pdpQtd() : 1); return; }

      /* Pagar, quando a LP abre pelo subdominio da marca (ver foraDoPrincipal) */
      var pay = alvo.closest('[data-ty-checkout]');
      if (pay && foraDoPrincipal()) { e.preventDefault(); irPagar(pay); return; }

      /* "Monte seu kit" */
      var kb = alvo.closest('[data-ty-kit]');
      if (kb && kb.tagName === 'BUTTON') { e.preventDefault(); e.stopPropagation(); alternaKit(kb.dataset.tyKit); return; }
      var krm = alvo.closest('[data-ty-kit-rm]');
      if (krm) { e.preventDefault(); e.stopPropagation(); alternaKit(krm.dataset.tyKitRm); return; }
      var kgo = alvo.closest('[data-ty-kit-go]');
      if (kgo) { e.preventDefault(); kitNoCarrinho(kgo); return; }
      var kpk = alvo.closest('[data-ty-kit-pick]');
      if (kpk) { e.preventDefault(); mostraGradeKit(); return; }

      /* linha: cartao, menu do celular e filtro da vitrine */
      var fam = alvo.closest('[data-ty-fam]');
      if (fam) { e.preventDefault(); fecharMenu(); filtra(fam.dataset.tyFam, true); return; }
      var fil = alvo.closest('[data-ty-fil]');
      if (fil) { e.preventDefault(); filtra(fil.dataset.tyFil, false); return; }

      /* "Kits" do menu e do rodape: seleciona a aba certa antes de rolar */
      var aba = alvo.closest('[data-ty-tab-go]');
      if (aba) { selecionaAba(aba.dataset.tyTabGo); fecharMenu(); return; }

      /* menu do celular: fecha antes de a ancora rolar */
      var ir = alvo.closest('[data-ty-menu-go]');
      if (ir && !ir.hasAttribute('data-ty-open-handle')) { fecharMenu(); }

      /* abrir ficha (botoes do banner, busca, rodape). Produto fora do
         mercado: deixa a ancora do link seguir para a vitrine. */
      var abre = alvo.closest('[data-ty-open-handle]');
      if (abre) {
        if (porHandle(abre.dataset.tyOpenHandle)) { e.preventDefault(); e.stopPropagation(); fecharBusca(); openPDP(abre.dataset.tyOpenHandle); }
        else fecharMenu();
        return;
      }

      var termo = alvo.closest('[data-ty-term]');
      if (termo) { e.preventDefault(); abrirBusca(termo.dataset.tyTerm); return; }

      var card = alvo.closest('.ty-card,.ty-kcard');
      if (card && card.dataset.tyHandle) { openPDP(card.dataset.tyHandle); return; }

      if (alvo.closest('[data-ty-search-open]')) { abrirBusca(); return; }
      if (alvo.closest('[data-ty-search-close]') || alvo.closest('[data-ty-search-veil]')) { fecharBusca(); return; }
      if (alvo.closest('[data-ty-menu-open]')) { abrirMenu(); return; }
      if (alvo.closest('[data-ty-menu-close]') || alvo.closest('[data-ty-menu-veil]')) { fecharMenu(); return; }
      if (alvo.closest('[data-ty-nostock-country]')) { abrirPais(); return; }
      if (alvo.closest('[data-ty-cart-open]')) { openCart(); return; }
      if (alvo.closest('[data-ty-cart-close]') || alvo.closest('[data-ty-cart-veil]')) { closeCart(); return; }
      if (alvo.closest('[data-ty-pdp-close]') || alvo === pdpOvl) { closePDP(); return; }

      var th = alvo.closest('[data-ty-th]');
      if (th) {
        var i = Number(th.dataset.tyTh), main = $('[data-ty-main]');
        if (PDP.p && main && PDP.p.img[i]) {
          main.src = imgW(PDP.p.img[i].s, 900);
          main.alt = PDP.p.img[i].a || PDP.p.t;
          $$('[data-ty-th]').forEach(function (b) { b.removeAttribute('aria-current'); });
          th.setAttribute('aria-current', 'true');
        }
        return;
      }
      var qty = alvo.closest('[data-ty-qty]');
      if (qty) {
        var linhaEl = qty.closest('.ty-line');
        var atual = CART.items.filter(function (it) { return it.key === linhaEl.dataset.key; })[0];
        if (atual) changeQty(atual.key, atual.quantity + Number(qty.dataset.tyQty));
        return;
      }
      var rm = alvo.closest('[data-ty-rm]');
      if (rm) { var l2 = rm.closest('.ty-line'); if (l2) changeQty(l2.dataset.key, 0); }
    });

    /* Teclado. O popup da garantia e um checkbox: o Escape fecha SO ele quando
       estiver aberto. <label role="button"> nao responde a Enter/Espaco
       sozinho — o navegador so liga label e controle no clique. */
    D.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var cbx = D.getElementById('ty-guar-cbx');
        if (cbx && cbx.checked) { cbx.checked = false; return; }
        closePDP(); closeCart(); fecharBusca(); fecharMenu(); fecharMenus(); return;
      }
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var el = e.target;
      if (!el || !el.closest) return;
      var lbl = el.closest('label[for="ty-guar-cbx"]');
      if (lbl) { e.preventDefault(); var c = D.getElementById('ty-guar-cbx'); if (c) c.checked = !c.checked; return; }
      var card = el.closest('.ty-card,.ty-kcard');
      if (card && card === el && card.dataset.tyHandle) { e.preventDefault(); openPDP(card.dataset.tyHandle); }
    });

    /* Subdominio da marca: testa o proxy ja (as trocas de pais/idioma e o pagar
       usam a resposta). Se um formulario de localizacao for enviado antes da
       resposta, ele espera e reenvia com o mesmo botao. */
    if (foraDoPrincipal()) {
      testaProxy();
      D.addEventListener('submit', function (e) {
        var f = e.target, a = f && f.getAttribute ? (f.getAttribute('action') || '') : '';
        if (!/\/localization$/.test(a) || a.charAt(0) !== '/' || f.__tyEspera) return;
        e.preventDefault();
        var quem = e.submitter || null;
        testaProxy().then(function (ok) {
          f.__tyEspera = true;
          if (!ok) retornoNaLP(f);
          if (f.requestSubmit) { if (quem) f.requestSubmit(quem); else f.requestSubmit(); } else f.submit();
        });
      }, true);
    }

    /* O resto do catalogo e o carrinho descem EM PARALELO, depois da primeira pintura. */
    carregarResto();
    fetchCart().then(marketHint);
  }

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init);
  else init();
})();
